// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 362 ? "b6715477" : chunkId) + "." + {"362":"fe56c0aa958846c2","604":"8d9f14bb2c1b00e5"}[chunkId] + ".js";
};